import { render, staticRenderFns } from "./PostoRead.vue?vue&type=template&id=745d936a&"
import script from "./PostoRead.vue?vue&type=script&lang=js&"
export * from "./PostoRead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports